<script setup lang="ts">
import HeroLegalContent from '~/components/pages/legal-content/Hero.vue'
import IconCookies from '~/components/icons/legal-content/IconCookies.vue'
import IntroductionSection from '~/components/pages/cookies/IntroductionSection.vue'
import WhatAreCookiesSection from '~/components/pages/cookies/WhatAreCookiesSection.vue'
import WhoOwnsSection from '~/components/pages/cookies/WhoOwnsSection.vue'
import UsedForSection from '~/components/pages/cookies/UsedForSection.vue'
import HowLongSection from '~/components/pages/cookies/HowLongSection.vue'
import ConsentSection from '~/components/pages/cookies/ConsentSection.vue'
import ConfigureSection from '~/components/pages/cookies/ConfigureSection.vue'
import ChangesSection from '~/components/pages/cookies/ChangesSection.vue'
import TransfersSection from '~/components/pages/cookies/TransfersSection.vue'
import DataSubjectSection from '~/components/pages/cookies/DataSubjectSection.vue'

definePageMeta({
	layout: 'legal',
})

const { $tThird } = useNuxtApp()

const getDescription = computed(() => {
	return $tThird(
		`To enhance your browsing experience, we use "cookies." These are small text files stored on your device that help us personalize content, remember your preferences, and understand how you interact with our website. This allows us to provide a more seamless and tailored experience for you.`,
	)
})
</script>

<template>
	<div class="relative w-full bg-white">
		<div class="bg-[#f5f8fa]">
			<div class="flex flex-col items-center gap-10 sm:gap-24 pb-10 sm:pb-24">
				<!-- Hero Section -->
				<HeroLegalContent
					:title="$tThird('About Our Use of Cookies')"
					:description="getDescription"
				>
					<template #icon>
						<IconCookies class="text-white size-10 sm:size-14" />
					</template>
				</HeroLegalContent>

				<!-- Content Section -->
				<div class="container">
					<div class="bg-white rounded-xl border border-gray-200 p-4 sm:p-14 space-y-10 sm:space-y-14">
						<IntroductionSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<WhatAreCookiesSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<WhoOwnsSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<UsedForSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<HowLongSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<ConsentSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<ConfigureSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<DataSubjectSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<TransfersSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<ChangesSection />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
